export const frequencies = [
  { id: 'once', label: 'Engång', multiplier: 1.0, desc: 'Ett tillfälle' },
  { id: 'monthly', label: 'Varje månad', multiplier: 1.05, desc: '1x per månad' },
  { id: 'biweekly', label: 'Varannan vecka', multiplier: 0.95, desc: '2x per månad' },
  { id: 'weekly', label: 'Varje vecka', multiplier: 0.9, desc: '4x per månad' },
];

export const baseRate = {
  privat: 48, // SEK/kvm före RUT
  foretag: 36, // SEK/kvm ex moms
};

export const minCharge = {
  privat: 950, // efter RUT
  foretag: 1200,
};

export const addOnRates = {
  windows: 10, // per kvm
  floors: 8,
  deep: 15,
};

export const initialModel = {
  mode: 'privat',
  area: 120,
  frequency: 'weekly',
  addOns: { windows: true, floors: false, deep: false },
  loyalty: true,
};
